<template>
  <div class="message-send">

    <div class="form-container">
      <van-form @submit="onSubmit">
        <!-- 选中的成员展示 -->
        <van-field
          name="members"
          label="推送对象"
        >
          <template #input>
            <div class="selected-members">
              {{ selectedMembers.map((item) => item.name).join(",") }}
            </div>
          </template>
        </van-field>
        <!-- 消息类型选择 -->
        <van-field
          name="message_type"
          label="消息类型"
          :rules="[{ required: true, message: '请至少选择一种消息类型' }]"
        >
          <template #input>
            <van-checkbox-group
              v-model="formData.message_types"
              direction="horizontal"
            >
              <van-checkbox name="text">文本</van-checkbox>
              <van-checkbox name="image">文件</van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>

        <!-- 文本消息内容 -->
        <van-field
          v-if="formData.message_types.includes('text')"
          v-model="formData.content_txt"
          name="content_txt"
          type="textarea"
          rows="4"
          label="消息内容"
          placeholder="请输入消息内容"
          :rules="[{ required: true, message: '请输入消息内容' }]"
        />

        <!-- 文件上传 -->
        <van-field
          v-if="formData.message_types.includes('image')"
          name="media"
          label="上传文件"
        >
          <template #input>
            <div class="upload-container">
              <div
                v-for="file in uploadedFiles"
                :key="file.file_id"
                class="upload-item"
              >
                <!-- 图片预览 -->
                <el-image
                  style="width: 60px; height: 60px"
                  :src="file.file_url"
                  :preview-src-list="[file.file_url]"
                >
                </el-image>
                <van-icon
                  name="clear"
                  class="upload-delete"
                  @click="onFileRemove(file)"
                />
              </div>
              <el-upload
                action=""
                class="media-uploader"
                :auto-upload="false"
                :show-file-list="false"
                :http-request="() => {}"
                :on-change="onFileChanged"
                :on-remove="onFileRemove"
                :on-exceed="handleExceed"
                :limit="9"
                :accept="uploadAccept"
                multiple
              >
                <div class="upload-trigger">
                  <van-icon
                    name="plus"
                    size="24"
                  />
                  <div class="upload-text">上传文件</div>
                </div>
              </el-upload>
            </div>
          </template>
        </van-field>

      </van-form>
    </div>
    <div class="submit-button">
      <el-button
        round
        block
        type="primary"
        @click="onSubmit"
      >
        发送
      </el-button>
    </div>
  </div>
</template>

<script>
import wecomAPI from "@/apis/wecom";
import { Toast } from "vant";
import systemService from "@/apis/system";
import { Message } from "element-ui";
import getUserInfo from "@/models/userInfo";

export default {
  name: "MessageSend",

  data() {
    return {
      formData: {
        message_types: [],
        content_txt: "",
        file_urls: [], // 统一存储所有文件URL
        create_user_type: "1",
        create_user_id: "",
        create_user_name: "",
      },
      uploadedFiles: [],
      selectedMembers: [],
      userInfo: {},
    };
  },

  computed: {
    uploadAccept() {
      return "image/jpeg,image/jpg,image/png";
    },
  },

  async created() {
    this.userInfo = await getUserInfo();
    this.initializeMembers();
  },

  methods: {
    onBack() {
      this.$router.back();
    },

    // 文件上传前的验证
    beforeUpload(file) {
      console.log(file);
      const isImage = file.raw.type.startsWith("image/");
      const isValidType = isImage;

      const maxSize = 200;
      const isValidSize = file.size / 1024 / 1024 < maxSize;

      if (!isValidType) {
        Message.error("请上传图片格式的文件!");
      }
      if (!isValidSize) {
        Message.error(`上传文件大小不能超过 ${maxSize}MB!`);
      }
      return isValidType && isValidSize;
    },

    // 处理文件选择变化
    onFileChanged(file) {
      if (!this.beforeUpload(file)) return;

      file.file_type = "image";

      this.$nextTick(() => {
        file.status = "uploading";
      });
      this.systemServiceUpload(file);
    },

    // 处理文件上传
    systemServiceUpload(file) {
      this.$nextTick(() => {
        file.status = "uploading";
      });
      const formData = new FormData();
      formData.append("file", file.raw);
      const query = {
        file_type: "wecom_file",
        file_name: file.name,
        file_ext: file.name.split(".").pop(),
        file_size: file.size,
      };

      const onUploadProgress = (progressEvent) => {
        const percentage =
          (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
        file.percentage = percentage;
        this.$forceUpdate();
      };

      systemService
        .upload(formData, query, onUploadProgress)
        .then((res) => {
          file.file_id = res.file_id;
          file.file_url = res.url;
          file.status = "success";
          this.uploadedFiles.push(file);
          this.formData.file_urls.push(res.url);
          this.$forceUpdate();
        })
        .catch(() => {
          Message.error("上传失败");
        });
    },

    // 处理文件删除
    onFileRemove(file) {
      this.uploadedFiles = this.uploadedFiles.filter(
        (item) => item.file_id !== file.file_id
      );
      this.formData.file_urls = this.formData.file_urls.filter(
        (url) => url !== file.file_url
      );
    },

    // 处理超出文件数限制
    handleExceed(files, fileList) {
      Message.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },

    // 提交表单
    async onSubmit() {
      // 验证至少选择了一种消息类型
      if (this.formData.message_types.length === 0) {
        Toast("请至少选择一种消息类型");
        return;
      }

      // 验证各种消息类型的必填内容
      if (
        this.formData.message_types.includes("text") &&
        !this.formData.content_txt
      ) {
        Toast("请输入文本消息内容");
        return;
      }

      if (
        this.formData.message_types.includes("image") &&
        this.uploadedFiles.length === 0
      ) {
        Toast("请上传文件");
        return;
      }

      try {
        const submitData = {
          ...this.formData,
          message_type: this.formData.message_types.join(","),
          image_url: this.uploadedFiles.map((item) => item.file_url),
          members: this.selectedMembers,
          create_user_type: 1,
          create_user_id: this.userInfo.user_id,
          create_user_name: this.userInfo.user_name,
        };

        await wecomAPI.createPushTask(submitData);
        Toast("发送成功");
        this.$router.back();
      } catch (error) {
        Toast("发送失败");
      }
    },

    // 初始化成员数据
    initializeMembers() {
      const membersQuery = this.$route.query.members;
      if (membersQuery) {
        try {
          this.selectedMembers = JSON.parse(membersQuery);
        } catch (error) {
          Toast("参数错误");
          this.$router.back();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.message-send {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;

  ::v-deep .van-field__label {
    color: #fff;
  }
  ::v-deep .van-radio__label {
    color: #fff;
  }
  ::v-deep .van-field__control {
    color: #fff;
  }

  .form-container {
    padding: 16px;
  }

  .selected-members {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    color: #fff;

    .member-tag {
      margin-right: 8px;
      margin-bottom: 8px;
    }
  }

  .upload-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .upload-item {
    position: relative;
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    background-color: #000;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .el-image {
      width: 100%;
      height: 100%;

      ::v-deep img {
        object-fit: cover;
      }
    }

    .upload-delete {
      position: absolute;
      top: 0;
      right: 0;
      padding: 4px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      cursor: pointer;
      z-index: 1;
    }
  }

  .media-uploader {
    display: inline-block;
  }

  .upload-trigger {
    width: 60px;
    height: 60px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: #fff;

    &:hover {
      border-color: #002d5c;
      color: #002d5c;
    }

    .upload-text {
      font-size: 12px;
      margin-top: 4px;
    }
  }
}

:deep(.el-upload) {
  width: 60px;
  height: 60px;
}

:deep(.el-image-viewer__wrapper) {
  z-index: 3000 !important;
}
::v-deep .van-checkbox__label {
  color: #fff;
}
.submit-button {
  margin-bottom: 40px;
  .el-button--primary {
    background-color: #002d5c;
    border-color: #002d5c;
    width: 100%;
  }
}
</style> 